<template>
  <el-dialog
    ref="bjDialog"
    class="bj-dialog"
    v-bind="$attrs"
    :visible.sync="visible"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div slot="title">
      <span>{{ title }}</span>
    </div>
    <slot></slot>
    <span
      slot="footer"
      class="bj-dialog-footer"
    >
      <slot name="footer">
        <el-button v-if="cancelText" @click="onCancel">{{ cancelText }}</el-button>
        <el-button v-if="confirmText" type="primary" @click="onConfirm">{{ confirmText }}</el-button>
      </slot>
    </span>
  </el-dialog>
</template>
<script>
import { throttle } from '@/utils';

export default {
  name: 'BjDialog',
  components: {},
  props: {
    cancelText: {
      type: [String, Boolean],
      default: () => '取消'
    },
    confirmText: {
      type: [String, Boolean],
      default: () => '确定'
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    beforeClose: {
      type: Function,
      default: (done) => done()
    },
    title: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {
  },
  mounted() {},
  methods: {
    onClose() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(() => {
          this.$emit('update:visible', false);
        });
      }
      else {
        this.$emit('update:visible', false);
      }
      this.$emit('onClose');
    },
    // onCancel() {
    //   this.$emit('onCancel');
    //   this.$emit('update:visible', false);
    // },
    onCancel: throttle(function() {
      this.$emit('onCancel');
    }, 2000, { leading: true, trailing: false }),
    onConfirm: throttle(function() {
      this.$emit('onConfirm');
    }, 2000, { leading: true, trailing: false })
  }
};
</script>
<style lang="less">
.bj-dialog{
  .el-dialog__body{
    padding: 20px;
  }
  .el-dialog__header{
    position: relative;
  }
  .el-dialog__headerbtn{
    top:50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
  }
}

</style>
